module.exports = __webpack_public_path__ + "static/media/test7_3.781021f9.png";